import { DASHBOARD_ACCESS } from "@/helpers/superAdminPermissionConstant";

export default [
    {
      path: "/super-admin-profile",
      name: "super-admin-profile",
      component: () => import("@/views/super-admin/profile/ProfileView.vue"),
      meta: {
        gate: DASHBOARD_ACCESS,
        pageTitle: "Super Admin Profile",
        requiresSuperAdmin: true,
        layout: "super-admin",
      },
    },
  ];
  